import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {Typography, useTheme} from "@mui/material";

const DateRangePickerComponent = ({
  variant = {},
  initialStartDate = moment().subtract(6, 'days'),
  initialEndDate = moment(),
  ranges = {
    "Last 24 Hours": [moment().subtract(1, 'day'), moment()],
    "Last 7 Days": [moment().subtract(6, 'days'), moment()],
    "This Month": [moment().startOf('month'), moment().endOf('month')],
    "A Year": [moment(), moment().add(1, 'year')]
    // "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    // "Last 90 Days": [moment().subtract(89, 'days'), moment()],
  },
  onDateRangeChange,
  style = {},
  className = ""
}) => {
  const [start, setStart] = useState(moment(initialStartDate));
  const [end, setEnd] = useState(moment(initialEndDate));
  const [rangeDisplay, setRangeDisplay] = useState("");
  const dateRangePickerRef = useRef(null);

  const theme = useTheme();

  useEffect(() => {
    if (moment(initialStartDate).isValid()) setStart(moment(initialStartDate));
    if (moment(initialEndDate).isValid()) setEnd(moment(initialEndDate));
  }, [initialStartDate, initialEndDate]);

  useEffect(() => {
    if (moment(start).isValid() && moment(end).isValid()) {
      setRangeDisplay(`${start.format('MMMM D, YYYY')} - ${end.format('MMMM D, YYYY')}`);
    }
  }, [start, end]);

  const handleCallback = (startMoment, endMoment) => {
    setStart(startMoment);
    setEnd(endMoment);
    if (onDateRangeChange) {
      onDateRangeChange(startMoment.format('YYYY-MM-DD'), endMoment.format('YYYY-MM-DD'));
    }
  };

  return (
    <div
      id="reportrange"
      style={{
        borderRadius: "5px", fontSize: 13, cursor: "pointer", padding: "8px", width: "fit-content", 
        display: "flex", alignItems: "center", height: "fit-content",
        backgroundColor: (variant === "booking_page") ? "#fff" : theme.palette.primary.main,
        border: (variant === "booking_page") ? `1px solid #dce8f5` : "none",
        ...style,
      }}
      className={className}
      ref={dateRangePickerRef}
    >
      <CalendarMonthIcon style={{width: "16px", height: "16px", marginRight: "5px", color: (variant === "booking_page") ? "hsl(0, 0%, 20%)" : "#fff"}} />
      <Typography sx={{fontSize: "15px", mr: 1, color: (variant === "booking_page") ? "hsl(0, 0%, 20%)" : "#fff"}}>Custom Picker:</Typography>
      

      <DateRangePicker
        initialSettings={{
            startDate: start,
            endDate: end,
            ranges,
        }}
        onCallback={handleCallback}
        >
          <Typography sx={{fontSize: "15.3px", m: "2px 3px 0px 0px", color: (variant === "booking_page") ? "hsl(0, 0%, 20%)" : "#fff"}}>{rangeDisplay}</Typography>
        </DateRangePicker>
    </div>
  );
};

export default DateRangePickerComponent;
